// components/dashboard/CustomizePanel.jsx
import React from 'react';
import { X, Eye, EyeOff, RotateCcw } from 'lucide-react';

const CustomizePanel = ({ isOpen, onClose, hiddenCards, toggleCardVisibility, resetLayout }) => {
  if (!isOpen) return null;

  const cards = [
    { id: 'totalDeals', name: 'Total Clients', description: 'Shows total number of deals' },
    { id: 'revenue', name: 'Total Revenue', description: 'Shows total revenue amount' },
    { id: 'lostDeals', name: 'Lost Clients', description: 'Shows number of lost deals' }
  ];

  return (
    <div className=" top-[41px] md:top-[57px] fixed inset-y-0 right-0 w-full max-w-2xl bg-white shadow-xl z-50 transform transition-transform duration-300">
      <div className="flex items-center justify-between p-4 border-b">
        <h3 className="text-lg font-semibold">Customize Dashboard</h3>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <div className="p-4 space-y-4">
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">Metric Cards</h4>
          <div className="space-y-2">
            {cards.map(card => (
              <div
                key={card.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div className="flex-1">
                  <p className="font-medium text-sm">{card.name}</p>
                  <p className="text-xs text-gray-500">{card.description}</p>
                </div>
                <button
                  onClick={() => toggleCardVisibility(card.id)}
                  className={`p-2 rounded-lg transition-colors ${
                    hiddenCards.includes(card.id) 
                      ? 'bg-gray-200 text-gray-400' 
                      : 'bg-red-50 text-red-600'
                  }`}
                >
                  {hiddenCards.includes(card.id) ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-4 border-t">
          <button
            onClick={resetLayout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
          >
            <RotateCcw className="h-4 w-4" />
            Reset Layout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomizePanel;
